
import localeEN from 'antd/es/date-picker/locale/en_GB';
import localeIT from 'antd/es/date-picker/locale/it_IT';
import { PickerLocale } from 'antd/lib/date-picker/generatePicker';
import moment, { Locale } from 'moment';

const locales: Record<string, PickerLocale> = {
    it: localeIT,
    en: localeEN
}
const momentLocales: Record<string, Locale> = {
    it: moment.localeData('it'),
    en: moment.localeData('en')
}
const currentLang = localStorage.getItem('ln') || 'it'

const currentLocale = locales[currentLang] || locales.en
const currentMomentLocales= momentLocales[currentLang] || momentLocales.en

export const pickerLocale: PickerLocale = {    
    ...currentLocale,
    "lang": {
        ...currentLocale.lang,
        shortMonths: currentMomentLocales.monthsShort(),
        shortWeekDays: currentMomentLocales.weekdaysShort(),
    }
}